export type GenericObject = { [key: string]: any };

export const common = {
    NEXT: 'dalje',
    PREVIOUS: 'nazad',
    SEND: 'pošalji',
    CLOSE: 'zatvori',
    QUIT: 'odustani',
    CONTINUE: 'nastavi',
};

export const translations = {
    CONFIRM: 'U redu',
    ERROR_MESSAGE: 'Proverite da li ste pravilno uneli sve podatke, ili pokušajte ponovo kasnije.',
    YES: 'da',
    NO: 'ne',
    userNotification: {
        CONFIRMATION_OF_APPLICANT: 'Potvrda podnosioca zahteva',
        RECIEVE_MESSAGE: 'Odaberite način za prijem jednokratne lozinke',
        SMS: 'SMS',
        EMAIL: 'Imejl',
        MSG_SENT: 'Poslali smo vam poruku/imejl',
        ONE_TIME_PASS: 'Jednokratna lozinka*',
        ERROR: 'Ne postoje podaci za unete kontakt podatke i privremenu lozinku!',
    },
    validationMessages: {
        EMAIL_ADDRESS_FORMAT: 'Potrebno je uneti e-mail adresu u odgovarajućem formatu (xx@xx.xx)',
        EMAIL_EXISTS: 'Ova e-mail adresa se već nalazi u listi dodatih adresa.',
    },
    emailsList: {
        CONFIRM_DELETE: 'Da li želite da obrišete ',
        tooltips: {
            ADD: 'Dodaj',
            EDIT: 'Izmeni',
            CANCEL: 'Odustani',
            DELETE: 'Obriši',
            CONFIRM: 'Potvrdi',
        },
    },
    intro: {
        DATA_PROCESSING_TITLE:
            'OBAVEŠTENJE O OBRADI PODATAKA O LIČNOSTI U POSTUPKU OBRADE ZAHTEVA ZA ISPLATU ŠTETE/NAKNADE/OSIGURANE SUME',
        DATA_PROCESSING_CONTENT:
            'GENERALI OSIGURANJE SRBIJA a.d.o. (u daljem tekstu: Društvo) u postupku po zahtevu za isplatu štete/naknade/osigurane sume, prikuplja lične podatke:',
        DATA_PROCESSING_CONTENT_LIST_1:
            'lično od osiguranika/korisnika osiguranja i/ili oštećenog prilikom podnošenja zahteva ili po naknadnom zahtevu ukoliko se utvrdi potreba za dopunom medicinske i druge dokumentacije za odlučivanje po zahtevu;',
        DATA_PROCESSING_CONTENT_LIST_2: 'od trećih lica sa kojima ima poslovnu saradnju u postupku likvidacija štete;',
        DATA_PROCESSING_CONTENT_LIST_3:
            'od zdravstvenih ustanova sa kojima ima zaključen ugovor o pružanju usluga (u kojima je osiguraniku/korisniku osiguranja i/ili oštećenom pružena medicinska usluga);',
        DATA_PROCESSING_CONTENT_LIST_4:
            'od Udruženja osiguravača Srbije, Ministarstva unutrašnjih poslova i drugih državnih organa koji vode odgovarajuće evidencije.',

        DATA_PROCESSING_SUBTITLE_1: 'Svrha obrade, pravni osnov i rok čuvanja',
        DATA_PROCESSING_CONTENT_1_1:
            'Sve lične podatke osiguranika/korisnika i/ili oštećenog Društvo obrađuje u svrhu ispunjenja obaveza iz ugovora o osiguranju. Ova obrada podataka se vrši na osnovu ugovora o osiguranju. Bez prikupljanja i obrade ličnih podataka osiguranika/korisnika osiguranja i/ili oštećenog Društvo nije u mogućnosti da ispuni svoje obaveze iz ugovora. Podaci koji se obrađuju u ovu svrhu čuvaju se 10 godina od utvrđivanja štete ili isplate ugovorenih iznosa iz ugovora o osiguranju.',
        DATA_PROCESSING_CONTENT_1_2:
            'Podatke o zdravstvenom stanju osiguranika/korisnika i/ili oštećenog Društvo obrađuje u svrhu ispunjenja ugovora o osiguranju. Ova obrada podataka se vrši na osnovu pristanka osiguranika/korisnika i/ili oštećenog. Bez prikupljanja i obrade ovih podataka Društvo nije u mogućnosti da izvrši ugovor. Podaci koji se obrađuju u ovu svrhu čuvaju se, u skladu sa zakonom, tokom čitavog trajanja ugovora o osiguranju i 10 godina posle isteka ugovora o osiguranju.',
        DATA_PROCESSING_CONTENT_1_3:
            'Prilikom likvidacije šteta po ugovoru o životnom osiguranju, Društvo obrađuje sve lične podatke osiguranika/korisnika osiguranja u svrhu ispunjenja zakonskih obaveza propisanih Zakonom o sprečavanju pranja novca i finansiranja terorizma i Sporazuma o usaglašenom oporezivanju inostranih računa (FATCA). Podaci koji se obrađuju u ovu svrhu čuvaju se, u skladu sa propisima, 10 godina.',
        DATA_PROCESSING_CONTENT_1_4:
            'Podatke podnosioca zahteva (ime, prezime, imejl adresu i broj telefona) Društvo obrađuje u svrhu kontaktiranja, slanja ponuda i obaveštenja o proizvodima osiguranja. Ova obrada podataka se vrši na osnovu dobrovoljno date saglasnosti (pristanka) podnosioca zahteva. Podaci koji se obrađuju u ovu svrhu čuvaju se pet godina ili do opoziva saglasnosti.',
        DATA_PROCESSING_CONTENT_1_5:
            'Podatke podnosioca zahteva (ime, prezime, imejl adresu i broj telefona) Društvo obrađuje u svrhu ispitivanja zadovoljstva klijenata povodom izvršenja ugovora o osiguranju. Ova obrada podataka se vrši na osnovu legitimnog interesa Društva koji se ogleda u poboljšavanju proizvoda osiguranja kroz bolje razumevanje potreba klijenata. Podaci koji se obrađuju u ovu svrhu čuvaju se do ispunjenja svrhe, a ne duže od godinu dana.',
        DATA_PROCESSING_CONTENT_1_6:
            'Sve lične podatke osiguranika/korisnika osiguranja, Društvo obrađuje u statističke svrhe radi procene rizika pri obnovi ili zaključenju budućih ugovora o osiguranju, primene pravila aktuarske struke i otkrivanja i sprečavanja prevara u osiguranju. Ova obrada podataka se vrši na osnovu legitimnog interesa Društva koji se ogleda u unapređivanju proizvoda osiguranja. Podaci koji se obrađuju u ovu svrhu čuvaju se 10 godina od utvrđivanja štete ili isplate ugovorenih iznosa iz ugovora o osiguranju.',

        DATA_PROCESSING_SUBTITLE_2: 'Pristup i prenos podataka',
        DATA_PROCESSING_CONTENT_2_1:
            'Sve podatke o ličnosti Društvo razmenjuje sa zdravstvenim ustanovama sa kojima ima zaključen ugovor o pružanju usluga, trećim licima sa kojima ima zaključen ugovor o poslovnoj saradnji (davanje medicinskog mišljenja i organizovanje lečenja osiguranika u inostranstvu), reosiguravaču ili saosiguravaču u cilju ispunjenja obaveza iz ugovora o osiguranju, članicama Generali grupe, trećim licima sa kojima Društvo ostvaruje saradnju u postupku likvidacije štete i trećim licima koja po zakonu moraju imati pristup tim podacima (Narodna banka Srbije, Uprava za sprečavanje pranja novca i drugi državni organi, eksterni revizori, sudovi i dr.).',
        DATA_PROCESSING_CONTENT_2_2:
            'Prenos podataka u drugu državu članicama Generali grupe i drugim eksternim partnerima vrši se u skladu sa odredbama Zakona o zaštiti podataka o ličnosti.',

        DATA_PROCESSING_SUBTITLE_3: 'Bezbednost podataka',
        DATA_PROCESSING_CONTENT_3:
            'Sve podatke koje obrađuje Društvo čuva u elektronskom obliku i fizički. Društvo sve podatke obrađuje kao poslovnu tajnu, uz primenu svih raspoloživih tehničkih i organizacionih mera zaštite podataka, u skladu sa zakonom i svojim internim aktima. Takođe, Društvo poseduje sertifikat ISO27001 koji reguliše zaštitu informacija kojima društvo raspolaže i do kojih dolazi u svom poslovanju.',

        DATA_PROCESSING_SUBTITLE_4: 'Prava u vezi s obradom podataka',
        DATA_PROCESSING_CONTENT_4_1:
            'Osiguranik/korisnik osiguranja i/ili oštećeni ima sva zakonska prava u pogledu obrade ličnih podataka, a to su: pravo na pristup, ispravku, dopunu i brisanje podataka o ličnosti, pravo na ograničenje obrade, pravo na prigovor i pravo na prenosivost podataka. Ukoliko je podnosilac zahteva dao saglasnost za obradu podataka o ličnosti, tu saglasnost može opozvati u svakom trenutku u skladu sa Zakonom o zaštiti podataka o ličnosti. Opoziv saglasnosti neće uticati na dopuštenost obrade na osnovu saglasnosti pre opoziva. ',
        DATA_PROCESSING_CONTENT_4_2:
            'Ukoliko smatra da je obrada podataka o ličnosti izvršena suprotno odredbama Zakona o zaštiti podataka o ličnosti, osiguranik/korisnik osiguranja i/ili oštećeni ima pravo da podnese pritužbu Povereniku za informacije od javnog značaja i zaštitu podataka o ličnosti.',

        DATA_PROCESSING_SUBTITLE_5: 'Kontakt',
        DATA_PROCESSING_CONTENT_5:
            'Za pitanja koje se tiču vaših prava u vezi sa obradom podataka o ličnosti možete kontaktirati sa Licem za zaštitu podatka o ličnosti putem:',
        DATA_PROCESSING_CONTENT_5_CALL_CENTER: 'kontakt centra: ',
        DATA_PROCESSING_CONTENT_5_CALL_CENTER_NUMBER: '011 222 0 555',
        DATA_PROCESSING_CONTENT_5_CALL_CENTER_NUMBER_HREF: 'tel:+381112220555',
        DATA_PROCESSING_CONTENT_5_EMAIL: 'e-pošte: ',
        DATA_PROCESSING_CONTENT_5_EMAIL_ADDRESS: 'dpo@generali.rs',
        DATA_PROCESSING_CONTENT_5_MAIL:
            'pošte: GENERALI OSIGURANJE SRBIJA a.d.o., Španskih boraca br. 3, 11070 Novi Beograd',

        ACCEPT_DATA_PROCESSING: 'Potvrđujem da sam upoznat sa sadržinom Obaveštenja o obradi podataka o ličnosti.',
        ACCEPT_DATA_PROCESSING_NOTIFICATION: 'Neophodno je da potvrdite saglasnost ukoliko želite da nastavite dalje.',
    },
    documentation: {
        CHOOSE_DOC: 'odaberi dokument',
        EXEEEDS_ALLOWED_SIZE: 'Ne možete da dodate pojedinačni dokument veći od ',
        TOTAL_UPLOAD_SIZE: 'Možete poslati najviše ',
        TOTAL_UPLOAD_SIZE_SUFFIX: ' priloga.',
        FILE_ALREADY_UPLOADED: 'Ne možete ponovo dodati isti fajl.',
        FORMAT_NOT_ALLOWED: 'Format fajla koji ste dodali nije odgovarajući.',
        DOCUMENTATION_MB: 'MB',
    },
};

export const popupContent = `
    <div id="dp-content-wrapper">
        <p>${translations.intro.DATA_PROCESSING_TITLE}</p>
        <p>${translations.intro.DATA_PROCESSING_CONTENT}</p>
        <p><ul>
        <li>${translations.intro.DATA_PROCESSING_CONTENT_LIST_1}</li>
        <li>${translations.intro.DATA_PROCESSING_CONTENT_LIST_2}</li>
        <li>${translations.intro.DATA_PROCESSING_CONTENT_LIST_3}</li>
        <li>${translations.intro.DATA_PROCESSING_CONTENT_LIST_4}</li>
        </ul></p>
        <p style="text-decoration: underline;">${translations.intro.DATA_PROCESSING_SUBTITLE_1}</p>
        <p><ol>
        <li>${translations.intro.DATA_PROCESSING_CONTENT_1_1}</li>
        <li>${translations.intro.DATA_PROCESSING_CONTENT_1_2}</li>
        <li>${translations.intro.DATA_PROCESSING_CONTENT_1_3}</li>
        <li>${translations.intro.DATA_PROCESSING_CONTENT_1_4}</li>
        <li>${translations.intro.DATA_PROCESSING_CONTENT_1_5}</li>
        <li>${translations.intro.DATA_PROCESSING_CONTENT_1_6}</li>                
        </ol></p>
        <p style="text-decoration: underline;">${translations.intro.DATA_PROCESSING_SUBTITLE_2}</p>
        <p>${translations.intro.DATA_PROCESSING_CONTENT_2_1}</p>
        <p>${translations.intro.DATA_PROCESSING_CONTENT_2_2}</p>
        <p style="text-decoration: underline;">${translations.intro.DATA_PROCESSING_SUBTITLE_3}</p>
        <p>${translations.intro.DATA_PROCESSING_CONTENT_3}</p>
        <p style="text-decoration: underline;">${translations.intro.DATA_PROCESSING_SUBTITLE_4}</p>
        <p>${translations.intro.DATA_PROCESSING_CONTENT_4_1}</p>
        <p>${translations.intro.DATA_PROCESSING_CONTENT_4_2}</p>
        <p style="text-decoration: underline;">${translations.intro.DATA_PROCESSING_SUBTITLE_5}</p>
        <p>${translations.intro.DATA_PROCESSING_CONTENT_5}
        </br> 
        <ul>
            <li>${translations.intro.DATA_PROCESSING_CONTENT_5_CALL_CENTER}
                <a 
                    style="color: #c21b17" 
                    href=${translations.intro.DATA_PROCESSING_CONTENT_5_CALL_CENTER_NUMBER_HREF} target="_blank">
                    ${translations.intro.DATA_PROCESSING_CONTENT_5_CALL_CENTER_NUMBER}
                </a>
            </li>
            <li>${translations.intro.DATA_PROCESSING_CONTENT_5_EMAIL}
                <a 
                    style="color: #c21b17" 
                    href=mailto:${translations.intro.DATA_PROCESSING_CONTENT_5_EMAIL_ADDRESS} target="_blank">
                    ${translations.intro.DATA_PROCESSING_CONTENT_5_EMAIL_ADDRESS}
                </a>
            </li>
            <li>${translations.intro.DATA_PROCESSING_CONTENT_5_MAIL}</li>
        </ul>
        </p>
    </div>
`;

export const applications = {
    portal: {
        NAME: 'portal',
        ID: 1,
    },
    website: {
        NAME: 'website',
        ID: 3,
    },
    callCenter: {
        NAME: 'callCenter',
        ID: 4,
    },
    webis: {
        NAME: 'webis',
        ID: 5,
    },
};

export const paymentOptions = [
    {
        label: 'Servis',
        value: '1',
    },
    {
        label: 'Tekući račun',
        value: '2',
    },
];

export class constValues {
    static readonly countrySerbiaId: number | string = 500;
    static readonly dialCodeSerbia: string = '+381';
}

export type ScreenProps = {
    navigator: GenericObject[];
    values: GenericObject[];
};

export const currentYear = new Date().getFullYear();
export const maxCharacterLimit = 500;
export const damageDescriptionCharacterLimit = 1000;
export const acceptedUploadFileTypes = '.pdf, .jpg, .jpeg, .png, .doc, .docx, .rtf, .xls, .xlsx, .txt';
export const acceptedUploadFileTypesArray = ['pdf', 'jpg', 'jpeg', 'png', 'doc', 'docx', 'rtf', 'xls', 'xlsx', 'txt'];
export const compressUploadFileTypesArray = ['jpg', 'jpeg', 'png'];
export const questionMaxLength = 100;
export const question50MaxLength = 50;
export const question25MaxLength = 25;
export const question10MaxLength = 10;
export const policyNoMaxLength = 10;
export const nameMaxLength = 20;
export const accountMaxLength = 18;
export const surnameMaxLength = 30;
export const ucnMaxLength = 13;
export const MAX_IMAGE_RESOLUTION = 2560;
export const IMAGE_COMPRESSION = 80;
